import React, { useState, Fragment, useEffect } from "react";
import { toggle } from "../Actions/Cart.action";
import { useOutsideClick } from "../Components/useOutsideClick";
import { translate } from '../Services/translation';

const Navigation = ({ links: topLinks = [], contentLink = null, mobileMenuExtraLinks: mobileMenuExtraLinks, logoUrl: logoUrl }) => {
    const [currentLink, setCurrentLink] = useState(); // Current link is used to check if we are on first level of menu or not.
    const [isOnFirstLevel, setIsOnFirstLevel] = useState(true);
    const [linksOpen, setLinksOpen] = useState([]);
    const links = currentLink ? currentLink.links : topLinks;

    let menuRef = React.createRef();
    const onOutsideClick = () => {
        if (menuVisible === true) {
            setMenuVisible(false);
            document.body.classList.remove('add-overlay');
        }
    }
    const [menuVisible, setMenuVisible] = useState(false);
    useOutsideClick(menuRef, onOutsideClick);

    function toggleMenu() {
        setMenuVisible(!menuVisible)
        if (menuVisible == false) {
            document.body.classList.add('add-overlay');
        }
        else {
            document.body.classList.remove('add-overlay');
        }

    }
    const closeMenu = () => {
        setCurrentLink(null);
        setMenuVisible(false);
        document.body.classList.remove('add-overlay');
    }

    const toggleLinkOpen = (link) => {
        setLinksOpen((currentOpenLinks) => {
            let linksCopy = [...currentOpenLinks];
            let currentIndex = linksCopy.indexOf(link);
            if (currentIndex != - 1) {
                linksCopy.splice(currentIndex, 1);
                return linksCopy;
            } else {
                return [...linksCopy, link];
            }
        })
    }

    const onLinkClick = (link) => {
        setCurrentLink(link);
        setLinksOpen([]);
    }

    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;


    return (
        <Fragment>
            {!contentLink ? (
                <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}></a>
            ) : (
                contentLink.name &&
                <>
                    <a className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`}
                        href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLink.name }} >
                    </a>
                    {links.length > 0 &&
                        <i className="navbar__icon--caret-left navbar__icon navbar__icon--open" onClick={() => onLinkClick(contentLink)}></i>
                    }
                </>
            )}
            <ul className={menuVisible ? "navbar__menu--show navbar__menu" : "navbar__menu"} ref={menuRef} test={links.length}>
                {!currentLink ? (
                    <div className="navbar__menu-header">
                        <img src={logoUrl} />
                        <span className="navbar__icon navbar__icon--close" onClick={() => closeMenu()}></span>
                    </div>
                ) : (
                    <Fragment>
                        {currentLink && currentLink.name &&
                            <>
                                <div className="navbar__menu-header">
                                    <i className="navbar__icon--caret-left navbar__icon" onClick={() => onLinkClick(null)}></i>
                                    <span className="navbar__title" onClick={() => onLinkClick(null)}>{translate('mobile-menu.go-back')}</span>
                                    <span className="navbar__icon navbar__icon--close" onClick={() => closeMenu()}></span>
                                </div>
                                <div className="navbar__item" ><a style={{ textTransform: currentLink ? 'capitalize' : null }} className="navbar__link" href={currentLink.url}>{translate('mobile-menu.show-all')} {currentLink.name}</a></div>
                            </>
                        }
                    </Fragment>
                )}
                {menuVisible &&
                    <>
                        {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                            <>
                                <li className={`navbar__item ${linksOpen.indexOf(link) != -1 && 'navbar__item--open'} `} key={link.name + i + 'item'}>
                                    {link.links.length > 0 ?
                                        <a style={{ textTransform: currentLink ? 'capitalize' : null }} className={`navbar__link ey ${hasChildrenClass || ''} ${additionClass || ''}`}
                                            onClick={() => currentLink != null ? toggleLinkOpen(link) : setCurrentLink(link)} dangerouslySetInnerHTML={{ __html: link.name }} >
                                        </a>
                                        :
                                        <a style={{ textTransform: currentLink ? 'capitalize' : null }} className={`navbar__link ${additionClass || ''} ${currentLink && 'navbar__link--'}`}
                                            href={link.url || '#'} dangerouslySetInnerHTML={{ __html: link.name }} >
                                        </a>
                                    }
                                    {link.links.length > 0 && (
                                        <i className={`${!currentLink ? 'navbar__icon--caret-right' : 'navbar__icon--caret-down'} navbar__icon navbar__icon--open`} onClick={() => currentLink != null ? toggleLinkOpen(link) : setCurrentLink(link)}></i>
                                    )
                                    }
                                </li>
                                {currentLink != null && link.links && link.links.length > 0 && linksOpen.indexOf(link) != -1 &&
                                    <ul className="navbar__expanded-menu">
                                        {link.url && link.url != "/" && link.url != "#" &&
                                            <li><a href={link.url}>{translate('mobile-menu.show-all')} {link.name}</a></li>
                                        }
                                        {link.links.map((childLink, i) =>
                                            <li key={childLink.name + i}>
                                                <a href={childLink.url}>
                                                    {childLink.name}
                                                </a>
                                            </li>
                                        )}
                                    </ul>}
                            </>
                        )}
                        <ul className="navbar__mobile-menu-extra-links">
                            {currentLink == null && mobileMenuExtraLinks && mobileMenuExtraLinks.map((link, i) => (
                                <li key={link.Text + i}><a href={link.Href}>{link.Text}</a></li>
                            ))
                            }
                        </ul>
                    </>
                }
            </ul>
        </Fragment>
    )
}

export default Navigation;